import React, { useEffect, useState } from 'react';
import { Check, FileText, Heart, Compass, AlertTriangle, Clock, BookOpen } from 'lucide-react';
import { Section } from './Shared';
import { Pricing } from './Pricing';
import { CandleFlame, TearDrop } from './SacredIcons';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 7,
    s: 57
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('constelaciones-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 68;
  });
  useEffect(() => {
    sessionStorage.setItem('constelaciones-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-208" data-mp="2yblxhvnuakkv">
      <div className="bg-brand-violet text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-goldLight/40" data-id="element-209" data-mp="338cc0ejzx846">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-xs font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-210" data-mp="y5gklqyjp8gr">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-211" data-mp="184xmryel947z">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-gold/40 bg-gradient-to-br from-white/95 to-brand-goldLight/10 shadow-[0_10px_40px_rgba(201,169,97,0.12)]" data-id="element-212" data-mp="1lx425i9x376d">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-213" data-mp="1hxv8edevn9at">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-goldDark shrink-0" data-id="element-214" data-mp="1vurxoafckipl" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-violetDark text-center" data-id="element-215" data-mp="1qx8lrh64gi0t">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-216" data-mp="3so3g04kok95f">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-217" data-mp="285jb50l6ay3u" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-218" data-mp="2861eeh696cl9">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-219" data-mp="2d3uldcfdraml" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-220" data-mp="1yghud86t0cot">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-221" data-mp="23dri8jejogaj" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-222" data-mp="1pfb7mhdka5n4">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-223" data-mp="1uf5xqipiir74" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-224" data-mp="1fhnefvvlt672">
            Después sube $10.000 ARS.{' '}
            <span className="text-brand-violet" data-id="element-225" data-mp="1kggqrkz5mr5n">No vuelve.</span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-gold/30" data-id="element-226" data-mp="39w6dfogxsrkc">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-227" data-mp="3esoi6oc9opwo">
            <div className="flex items-center gap-2" data-id="element-228" data-mp="1eqf870pc0ndq">
              <span className="relative flex h-2.5 w-2.5" data-id="element-229" data-mp="1aq4zhga5niv6">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-burgundy opacity-75" data-id="element-230" data-mp="1aqmyuls46d7b"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-burgundy" data-id="element-231" data-mp="10rxode2jrv13"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-232" data-mp="vte2fdnyej8q">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-violet uppercase tracking-wide" data-id="element-233" data-mp="r0b30owhwfkm">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-gold/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-234" data-mp="i30s54nlasg8">
            <div className="bg-gradient-to-r from-brand-gold to-brand-goldDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-235" data-mp="d11qbz7i03le" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-236" data-mp="2y67r37pwjj5">
            <strong className="text-brand-violet" data-id="element-237" data-mp="3095k9f43gyf">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const libroPrincipal = {
  title: 'VADEMÉCUM DEL CONSTELADOR FAMILIAR™',
  tagline: 'Tu manual de guardia para cuando el campo se traba.',
  cover: 'https://cdn.magicpatterns.com/uploads/rr2zBQyGuf68HB29iyNPfi/Portada_vademecum.png',
  color: 'text-brand-violetDark',
  bgColor: 'bg-brand-violetDark/5',
  borderColor: 'border-brand-violetDark/20',
  bullets: ['Preguntas sistémicas por vínculo y temática', 'Frases de anclaje rápido para intervenir con precisión', 'Protocolos de rescate cuando la sesión se estanca', 'Checklist de apertura y cierre de sesión', 'Árbol de decisión del constelador', 'Glosario sistémico esencial']
};
const bonuses = [{
  icon: Heart,
  title: '100 Preguntas Poderosas™',
  desc: 'Abrí información profunda del sistema familiar.',
  cover: 'https://cdn.magicpatterns.com/uploads/pnTggaLDLj8E1dKchAPQTy/Portada_bono_1_CF.png',
  color: 'text-brand-violet',
  bgColor: 'bg-brand-violet/10',
  borderColor: 'border-brand-violet/30',
  price: '$10.000'
}, {
  icon: FileText,
  title: '100 Frases Sanadoras™',
  desc: 'La frase justa en el momento exacto.',
  cover: 'https://cdn.magicpatterns.com/uploads/8HEJiP8LzEe825WwyZpyf6/portada_bono_2_CF.png',
  color: 'text-brand-burgundy',
  bgColor: 'bg-brand-burgundy/10',
  borderColor: 'border-brand-burgundy/30',
  price: '$10.000'
}, {
  icon: Compass,
  title: 'Tarjeta de Consulta Rápida™',
  desc: 'Fichas imprimibles para el escritorio durante la sesión.',
  cover: 'https://cdn.magicpatterns.com/uploads/bDHFpP5cRwqfrUjRCndaam/Portada_bono_3_CF.png',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  price: '$8.000'
}, {
  icon: BookOpen,
  title: 'Guía de Primeros Pasos™',
  desc: 'El sistema de arranque que nadie te enseñó.',
  cover: 'https://cdn.magicpatterns.com/uploads/iJrb9TTfdo3GAyKnsj7Pqt/portada_bono_4_CF.png',
  color: 'text-brand-forest',
  bgColor: 'bg-brand-forest/10',
  borderColor: 'border-brand-forest/30',
  price: '$8.000'
}];
const maestriaCover = 'https://cdn.magicpatterns.com/uploads/5TXC1ecrY3xWX1UBcSXDU5/portada_para_la_maestria_de_constelaciones.png';
const planComparison = [{
  situation: 'El campo se detiene y no sabés hacia dónde ir',
  without: 'Improvisás o cambiás de tema',
  with: 'Protocolo de intervención avanzada. Dirección clara.'
}, {
  situation: 'El consultante llega resistente y no se mueve',
  without: 'Forzás el proceso o te frustrás',
  with: 'Lectura sistémica de la resistencia aplicada en sesión'
}, {
  situation: 'Sentís que te perdiste en el campo del consultante',
  without: 'No sabés distinguir si es tuyo o del campo',
  with: 'Protocolo de contratransferencia sistémica.'
}, {
  situation: 'Querés trabajar trauma profundo con seguridad',
  without: 'Evitás el tema o lo abrís sin contención',
  with: 'Protocolo de regulación somática paso a paso'
}, {
  situation: 'Tenés dificultad para cobrar lo que vale tu trabajo',
  without: 'Seguís con honorarios bajos por creencia propia',
  with: 'Revisión sistémica del propio sistema económico'
}, {
  situation: 'No sabés cuándo cerrar un proceso',
  without: 'Lo extendés más de lo necesario',
  with: '7 señales de cierre y protocolo de despedida de maestría'
}, {
  situation: 'Sesiones que no tienen la profundidad que querés',
  without: 'La técnica está pero falta algo',
  with: 'Desarrollo de la presencia vacía como instrumento'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-238" data-mp="1kg6r3xrlfpgf">
      {/* Decorative Sacred elements */}
      <CandleFlame className="hidden lg:block absolute top-20 right-[3%] w-8 h-12 opacity-25 animate-float-soft" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-239" data-mp="1pf07pz26fwkt" />
      <TearDrop className="hidden lg:block absolute top-60 left-[2%] w-10 h-12 opacity-30 animate-float-soft" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-240" data-mp="1z41ovskgkk0d" />

      {/* Compact header + mockup */}
      <div className="max-w-4xl mx-auto mb-5 md:mb-6" data-id="element-241" data-mp="2d3je291o1za9">
        <div className="text-center mb-2.5 md:mb-3" data-id="element-242" data-mp="2d42mmz5ffbbm">
          <div className="inline-flex items-center space-x-1.5 bg-white border border-brand-gold/40 px-3 py-0.5 rounded-full mb-1.5 shadow-sm" data-id="element-243" data-mp="2i2dvb6jzjfs9">
            <span className="text-sm" data-id="element-244" data-mp="ir2zmkypveub">🏆</span>
            <span className="font-serif font-semibold tracking-wider text-brand-violetDark text-[10px] md:text-xs" data-id="element-245" data-mp="nocyer7zx2ut">
              VADEMÉCUM DEL CONSTELADOR FAMILIAR™
            </span>
          </div>
          <h2 className="text-lg md:text-3xl font-display font-bold leading-tight text-brand-violetDark mb-0.5" data-id="element-246" data-mp="w6zd59ibm2zg">
            Libro Principal + 4 Bonos
          </h2>
          <p className="text-brand-text/70 text-[11px] md:text-sm" data-id="element-247" data-mp="1150yy274sgem">
            230 páginas — Todo resuelto.
          </p>
        </div>

        <div className="relative z-10 w-full max-w-[260px] sm:max-w-sm md:max-w-lg mx-auto flex justify-center" data-id="element-248" data-mp="1a7a38abt3djk">
          <img src="https://cdn.magicpatterns.com/uploads/jgqUKEUS13fnqZXbBzCZz9/mokup_sin_fondo_CF.png" alt="Vademécum del Constelador Familiar + Bonos" className="w-full h-auto drop-shadow-2xl" draggable={false} data-id="element-249" data-mp="1f5bp130m9qyq" />
        </div>
      </div>

      <div className="max-w-4xl mx-auto mb-8" data-id="element-250" data-mp="1sy9ph3rx2995">
        <div className="space-y-3 md:space-y-4" data-id="element-251" data-mp="1svf4nb4zqmf7">
          {/* Libro Principal Card */}
          <div className={`rounded-xl p-4 md:p-6 border ${libroPrincipal.bgColor} ${libroPrincipal.borderColor} backdrop-blur-sm shadow-sm`} data-id="element-252" data-mp="1xwuqh5ezswyn">
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-253" data-mp="3df9d1ju4dxut">
              <div className="shrink-0 w-32 sm:w-40 md:w-48" data-id="element-254" data-mp="39dfjdvicdu45">
                <img src={libroPrincipal.cover} alt={libroPrincipal.title} className="w-full h-auto rounded-md shadow-lg" draggable={false} data-id="element-255" data-mp="39g1rpxd24dnf" />
              </div>

              <div className="flex-grow min-w-0 text-center md:text-left" data-id="element-256" data-mp="xvv7awj31vy">
                <div className={`inline-block text-[10px] md:text-xs font-mono font-bold ${libroPrincipal.color} ${libroPrincipal.bgColor} border ${libroPrincipal.borderColor} px-2 py-0.5 rounded mb-2`} data-id="element-257" data-mp="3scjpowii19s4">
                  📘 LIBRO PRINCIPAL
                </div>
                <h4 className="font-serif font-bold mb-1 text-base md:text-xl text-brand-violetDark leading-tight" data-id="element-258" data-mp="jx9p5su9ccmg">
                  {libroPrincipal.title}
                </h4>
                <p className="text-brand-text/80 italic mb-4 text-xs md:text-base leading-snug" data-id="element-259" data-mp="12vl174qvs9tr">
                  {libroPrincipal.tagline}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-xs md:text-sm text-brand-text/85 text-left" data-id="element-260" data-mp="u05bmzx5sgtz">
                  {libroPrincipal.bullets.map((bullet, j) => <div key={j} className="flex items-start" data-id="element-261" data-mp="k1zaikj6feq6" data-mpi={j}>
                      <Check className={`w-4 h-4 mr-2 mt-0.5 shrink-0 ${libroPrincipal.color}`} data-id="element-262" data-mp="p1k6cm31v6yo" />
                      <span className="leading-snug" data-id="element-263" data-mp="b3na5qsid2kj">{bullet}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-4 mt-10" data-id="element-264" data-mp="25gljo86dvv6t">
          <h3 className="text-lg md:text-xl font-serif font-bold text-brand-violetDark" data-id="element-265" data-mp="29hf4utsfyvw0">
            🎁 4 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-[10px] md:text-xs uppercase tracking-wider text-brand-goldDark mt-0.5 font-bold" data-id="element-266" data-mp="3u0j1e67ei9ot">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-267" data-mp="7koj89ozdmr8">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="glass-panel rounded-xl p-4 border-brand-gold/30 relative bg-white/90 flex items-start gap-3" data-id="element-268" data-mp="2rlldpd67r58" data-mpi={i}>
                <div className="shrink-0 w-16 sm:w-20" data-id="element-269" data-mp="ciyeslemapdd">
                  <img src={bonus.cover} alt={bonus.title} className="w-full h-auto rounded-md shadow-md" draggable={false} data-id="element-270" data-mp="qj961pjua5z2" />
                </div>
                <div className="flex-grow min-w-0" data-id="element-271" data-mp="2sam8m7yc41ry">
                  <div className="flex items-center gap-2 mb-1" data-id="element-272" data-mp="2nc2lw5bx2lyj">
                    <div className={`${bonus.bgColor} ${bonus.color} rounded-md p-1 shrink-0`} data-id="element-273" data-mp="2ndnh7x6228xg">
                      <Icon className="w-3.5 h-3.5" data-id="element-274" data-mp="2tqrlt32vjti4" />
                    </div>
                    <span className="bg-brand-goldDark text-white text-[10px] font-bold px-2 py-0.5 rounded shrink-0" data-id="element-275" data-mp="2yqvy0gwr222j">
                      GRATIS
                    </span>
                  </div>
                  <h4 className="text-sm md:text-base font-serif font-bold text-brand-text leading-tight mb-1" data-id="element-276" data-mp="2628h0xj19yus">
                    {bonus.title}
                  </h4>
                  <p className="text-xs text-brand-text/70 leading-snug mb-1.5" data-id="element-277" data-mp="2ayyxhlyr2wgq">
                    {bonus.desc}
                  </p>
                  <p className="text-[11px] text-brand-text/50" data-id="element-278" data-mp="2krd16k9e2d5j">
                    <span className="line-through" data-id="element-279" data-mp="2kso3efn6rcuj">{bonus.price}</span>
                    <span className="ml-1.5 font-semibold text-brand-goldDark" data-id="element-280" data-mp="1naxs2lwvbw5j">
                      → Incluido
                    </span>
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-5" data-id="element-281" data-mp="1fry9ujl58anr">
          <div className="inline-block glass-panel px-5 py-2 rounded-full border-brand-gold/30 bg-white/80" data-id="element-282" data-mp="1fsziyiilmn2u">
            <p className="text-xs md:text-sm font-medium text-brand-text/80" data-id="element-283" data-mp="1ark3r733rasd">
              Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-284" data-mp="15tikal1rl9gd">$36.000</span>{' '}
              <span className="text-brand-violet font-bold" data-id="element-285" data-mp="11tq5vrpow933">
                → GRATIS con tu Vademécum
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-286" data-mp="s3f1y5609zw7" />

      <Pricing data-id="element-287" data-mp="s2vgwfl26vdy" />

      {/* Maestría Comparison */}
      <div className="max-w-5xl mx-auto mb-6 mt-8" data-id="element-288" data-mp="n3iu1uu6tobd">
        <div className="bg-white rounded-2xl p-5 md:p-8 border border-brand-gold/30 shadow-sm" data-id="element-289" data-mp="n53svwnjbtf1">
          <div className="relative z-10 w-full max-w-[220px] sm:max-w-[260px] mx-auto mb-5" data-id="element-290" data-mp="i3eeq850mzmq">
            <img src={maestriaCover} alt="Maestría en Consulta Sistémica™ — Upsell exclusivo" className="w-full h-auto rounded-xl shadow-lg ring-1 ring-brand-gold/30" draggable={false} data-id="element-291" data-mp="e348qvh8497v" />
          </div>
          <p className="text-base md:text-xl font-serif font-bold text-brand-violetDark mb-6 text-center" data-id="element-292" data-mp="3qmymsgk7003h">
            🎓 ¿Qué agrega la Maestría en Consulta?
          </p>

          <div className="hidden md:block" data-id="element-293" data-mp="n5q4jvljyy88">
            <div className="grid grid-cols-3 gap-4 text-[11px] font-semibold uppercase tracking-wide text-brand-text/60 border-b border-brand-gold/20 pb-3 mb-3" data-id="element-294" data-mp="n6rfm02kjkpy">
              <div data-id="element-295" data-mp="dg6lopxub4dd">Situación</div>
              <div className="text-brand-burgundy" data-id="element-296" data-mp="deviosc7y0nb">❌ Sin Maestría</div>
              <div className="text-brand-violet" data-id="element-297" data-mp="ie86pgettdrh">✅ Con Maestría</div>
            </div>
            <div className="space-y-3" data-id="element-298" data-mp="164lwf09xv0iw">
              {planComparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 text-xs md:text-sm text-brand-text/80 py-2 border-b border-brand-gold/10 last:border-0" data-id="element-299" data-mp="1av2bspxbkw7w" data-mpi={i}>
                  <div className="font-medium pr-4" data-id="element-300" data-mp="1g8ise7e7jj61">{row.situation}</div>
                  <div className="text-brand-burgundy/80 pr-4" data-id="element-301" data-mp="1g66blxk6reuk">
                    {row.without}
                  </div>
                  <div className="text-brand-violet font-medium" data-id="element-302" data-mp="1p0uitt9bn6m0">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="md:hidden space-y-4" data-id="element-303" data-mp="x9eo1bxm2dkp">
            {planComparison.map((row, i) => <div key={i} className="border-b border-brand-gold/15 pb-4 last:border-0 last:pb-0" data-id="element-304" data-mp="1b967vtat6o6m" data-mpi={i}>
                <p className="text-sm font-semibold text-brand-text mb-2" data-id="element-305" data-mp="1691tc8tgo3j1">
                  {row.situation}
                </p>
                <div className="text-xs text-brand-burgundy/80 mb-1" data-id="element-306" data-mp="2mmi7frzjckmz">
                  ❌ {row.without}
                </div>
                <div className="text-xs text-brand-violet font-medium" data-id="element-307" data-mp="g02p5sh6zj22">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>

          <p className="text-sm md:text-base font-medium text-brand-goldDark italic text-center mt-8" data-id="element-308" data-mp="jzl6yfdpve0o">
            Un solo proceso mejorado con esta guía ya paga la diferencia de
            precio.
          </p>
        </div>
      </div>
    </Section>;
};